(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  document.documentElement.classList.remove('no-js');

  const moneyFormat = window.StarryTheme?.moneyFormat || '${{amount}}';
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(value)).toString())
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  }

  function setChromeVars() {
    const announcement = $('[data-announcement-bar]');
    const header = $('[data-site-header]');
    document.documentElement.style.setProperty('--announcement-height', `${announcement ? announcement.offsetHeight : 0}px`);
    document.documentElement.style.setProperty('--header-height', `${header ? header.offsetHeight : 0}px`);
  }
    setChromeVars();
  window.addEventListener('resize', setChromeVars);
  document.addEventListener('shopify:section:load', setChromeVars);

    // Collapsible search bar + predictive product search
  let headerSearchLastScrollY = Math.max(window.scrollY, 0);
  let headerSearchDirectionStartY = headerSearchLastScrollY;
  let headerSearchDirection = null;
  let headerSearchTicking = false;
  let headerSearchAbortController = null;
  let headerSearchDebounceTimer = null;

  const headerSearchThreshold = 24;

  function getHeaderSearchBars() {
    return $$('[data-header-search]');
  }

  function showHeaderSearch(bar) {
    bar.classList.remove('is-hidden-by-scroll');
    bar.setAttribute('aria-hidden', 'false');
  }

  function hideHeaderSearch(bar) {
    if (bar.matches(':focus-within')) return;

    bar.classList.add('is-hidden-by-scroll');
    bar.setAttribute('aria-hidden', 'true');

    const results = bar.querySelector('[data-header-search-results]');
    const input = bar.querySelector('[data-header-search-input]');

    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }

    if (input) {
      input.setAttribute('aria-expanded', 'false');
    }
  }

  function updateHeaderSearchBars() {
    const currentScrollY = Math.max(window.scrollY, 0);
    const movement = currentScrollY - headerSearchLastScrollY;

    let newDirection = headerSearchDirection;

    if (movement > 0) {
      newDirection = 'down';
    } else if (movement < 0) {
      newDirection = 'up';
    }

    if (newDirection && newDirection !== headerSearchDirection) {
      headerSearchDirection = newDirection;
      headerSearchDirectionStartY = currentScrollY;
    }

    const distanceInDirection = Math.abs(
      currentScrollY - headerSearchDirectionStartY
    );

    getHeaderSearchBars().forEach(bar => {
      const alwaysShow = bar.dataset.alwaysShow === 'true';

      if (alwaysShow || currentScrollY <= 4) {
        showHeaderSearch(bar);
        return;
      }

      if (distanceInDirection < headerSearchThreshold) {
        return;
      }

      if (headerSearchDirection === 'down') {
        hideHeaderSearch(bar);
      }

      if (headerSearchDirection === 'up') {
        showHeaderSearch(bar);
      }
    });

    headerSearchLastScrollY = currentScrollY;
    headerSearchTicking = false;
  }

  function requestHeaderSearchUpdate() {
    if (headerSearchTicking) return;

    headerSearchTicking = true;
    window.requestAnimationFrame(updateHeaderSearchBars);
  }

  function escapeHeaderSearchHtml(value = '') {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function closeHeaderSearchResults(bar) {
    const results = bar?.querySelector('[data-header-search-results]');
    const input = bar?.querySelector('[data-header-search-input]');

    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }

    if (input) {
      input.setAttribute('aria-expanded', 'false');
    }
  }

  function renderHeaderSearchResults(bar, products, query) {
    const results = bar.querySelector('[data-header-search-results]');
    const input = bar.querySelector('[data-header-search-input]');

    if (!results || !input) return;

    if (!products.length) {
      results.innerHTML = `
        <div class="header-search-results__empty">
          No products found for “${escapeHeaderSearchHtml(query)}”
        </div>
      `;

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    const productItems = products.map(product => {
      const imageUrl =
        product.image?.url ||
        product.featured_image?.url ||
        product.featured_image ||
        '';

      const imageAlt =
        product.image?.alt ||
        product.featured_image?.alt ||
        product.title ||
        '';

      const imageMarkup = imageUrl
        ? `
          <div class="header-search-results__image">
            <img
              src="${escapeHeaderSearchHtml(imageUrl)}&width=128"
              alt="${escapeHeaderSearchHtml(imageAlt)}"
              width="64"
              height="64"
              loading="lazy"
            >
          </div>
        `
        : `
          <div class="header-search-results__image">
            <div class="header-search-results__placeholder"></div>
          </div>
        `;

      const vendorMarkup = product.vendor
        ? `
          <span class="header-search-results__vendor">
            ${escapeHeaderSearchHtml(product.vendor)}
          </span>
        `
        : '';

      const priceMarkup = product.price
        ? `
          <span class="header-search-results__price">
            ${escapeHeaderSearchHtml(product.price)}
          </span>
        `
        : '';

      return `
        <li class="header-search-results__item" role="option">
          <a
            class="header-search-results__link"
            href="${escapeHeaderSearchHtml(product.url)}"
          >
            ${imageMarkup}

            <span class="header-search-results__details">
              ${vendorMarkup}

              <span class="header-search-results__title">
                ${escapeHeaderSearchHtml(product.title)}
              </span>

              ${priceMarkup}
            </span>
          </a>
        </li>
      `;
    }).join('');

    const cleanQuery = query.trim().replace(/\*+$/g, '');

const structuredQuery =
  `(title:${cleanQuery}* OR vendor:${cleanQuery}*)`;

const searchUrl =
  `${window.Shopify?.routes?.root || '/'}search?q=` +
  encodeURIComponent(structuredQuery) +
  '&type=product';

    results.innerHTML = `
      <ul class="header-search-results__list">
        ${productItems}
      </ul>

      <a
        class="header-search-results__view-all"
        href="${escapeHeaderSearchHtml(searchUrl)}"
      >
        View all results
      </a>
    `;

    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  async function fetchHeaderSearchResults(input) {
    const bar = input.closest('[data-header-search]');
    const query = input.value.trim();

    if (!bar || query.length < 1) {
      closeHeaderSearchResults(bar);
      return;
    }

    if (headerSearchAbortController) {
      headerSearchAbortController.abort();
    }

    headerSearchAbortController = new AbortController();

    const root = window.Shopify?.routes?.root || '/';

    const requestUrl =
  `${root}search/suggest.json?q=${encodeURIComponent(query)}` +
  '&resources[type]=product' +
  '&resources[limit]=50' +
  '&resources[options][unavailable_products]=show' +
  '&resources[options][fields]=title,vendor';

    try {
      const response = await fetch(requestUrl, {
        signal: headerSearchAbortController.signal,
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Predictive search failed: ${response.status}`);
      }

      const data = await response.json();

      if (input.value.trim() !== query) return;

      const rawProducts =
  data?.resources?.results?.products ||
  [];

const normalizedQuery = query
  .trim()
  .toLowerCase();

const wordStartsWithQuery = value => {
  return String(value || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/i)
    .filter(Boolean)
    .some(word => word.startsWith(normalizedQuery));
};

const products = rawProducts
  .filter(product => {
    return (
      wordStartsWithQuery(product.title) ||
      wordStartsWithQuery(product.vendor)
    );
  })
  .slice(0, 6);

      renderHeaderSearchResults(bar, products, query);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
        closeHeaderSearchResults(bar);
      }
    }
  }

  function handleHeaderSearchInput(input) {
  window.clearTimeout(headerSearchDebounceTimer);

  const bar = input.closest('[data-header-search]');
  const results = bar?.querySelector('[data-header-search-results]');
  const query = input.value.trim();

  if (!bar || !results || query.length < 1) {
    closeHeaderSearchResults(bar);
    return;
  }

  const searchingText =
    bar.dataset.searchingText ||
    'Searching...';

  results.innerHTML = `
    <div class="header-search-results__empty">
      ${escapeHeaderSearchHtml(searchingText)}
    </div>
  `;

  results.hidden = false;
  input.setAttribute('aria-expanded', 'true');

  headerSearchDebounceTimer = window.setTimeout(() => {
    fetchHeaderSearchResults(input);
  }, 180);
}

  window.addEventListener('scroll', requestHeaderSearchUpdate, {
    passive: true
  });

  document.addEventListener('input', event => {
    const input = event.target.closest('[data-header-search-input]');

    if (!input) return;

    handleHeaderSearchInput(input);
  });

  document.addEventListener('focusin', event => {
    const input = event.target.closest('[data-header-search-input]');
    const bar = event.target.closest('[data-header-search]');

    if (bar) {
      showHeaderSearch(bar);
    }

    if (input && input.value.trim().length >= 1) {
  handleHeaderSearchInput(input);
}
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;

    const bar = event.target.closest('[data-header-search]');

    if (bar) {
      closeHeaderSearchResults(bar);
      bar.querySelector('[data-header-search-input]')?.blur();
    }
  });

  document.addEventListener('click', event => {
    getHeaderSearchBars().forEach(bar => {
      if (!bar.contains(event.target)) {
        closeHeaderSearchResults(bar);
      }
    });
  });

  document.addEventListener('shopify:section:load', event => {
    const searchBar = event.target.querySelector?.(
      '[data-header-search]'
    );

    if (searchBar) {
      showHeaderSearch(searchBar);
      closeHeaderSearchResults(searchBar);

      headerSearchLastScrollY = Math.max(window.scrollY, 0);
      headerSearchDirectionStartY = headerSearchLastScrollY;
      headerSearchDirection = null;

      setChromeVars();
    }
  });

  document.addEventListener('shopify:section:unload', event => {
    const searchBar = event.target.querySelector?.(
      '[data-header-search]'
    );

    if (searchBar) {
      closeHeaderSearchResults(searchBar);
    }
  });

  updateHeaderSearchBars();

  // Full Search page — search word prefixes in title and vendor only
document.addEventListener('submit', event => {
  const form = event.target.closest('[data-main-search-form]');

  if (!form) return;

  const input = form.querySelector('[data-main-search-input]');

  if (!input) return;

  const query = input.value
    .trim()
    .replace(/^\(title:/i, '')
    .replace(/\*\s+OR\s+vendor:.*\*\)$/i, '')
    .replace(/\*+$/g, '');

  if (!query) return;

  input.value = `(title:${query}* OR vendor:${query}*)`;
});


  // Mobile menu
const menu = $('[data-mobile-menu]');

const closeAllMobileSubmenus = () => {
  if (!menu) return;

  menu.querySelectorAll('[data-submenu-toggle]').forEach(toggle => {
    toggle.setAttribute('aria-expanded', 'false');

    const item = toggle.closest(
      '.mobile-menu__item, .mobile-menu__submenu-item'
    );

    const submenu = item?.querySelector(':scope > [data-submenu]');

    if (submenu) {
      submenu.hidden = true;
    }

    item?.classList.remove('is-submenu-open');
  });
};

const toggleMobileSubmenu = toggle => {
  if (!toggle) return;

  const item = toggle.closest(
    '.mobile-menu__item, .mobile-menu__submenu-item'
  );

  const submenu = item?.querySelector(':scope > [data-submenu]');

  if (!submenu) return;

  const isOpen = toggle.getAttribute('aria-expanded') === 'true';

  toggle.setAttribute('aria-expanded', String(!isOpen));
  submenu.hidden = isOpen;
  item.classList.toggle('is-submenu-open', !isOpen);

  toggle.setAttribute(
    'aria-label',
    `${isOpen ? 'Open' : 'Close'} submenu`
  );
};

menu?.addEventListener('click', event => {
  const toggle = event.target.closest('[data-submenu-toggle]');

  if (toggle) {
    event.preventDefault();
    event.stopPropagation();

    toggleMobileSubmenu(toggle);
    return;
  }

  const parentLink = event.target.closest(
    '.mobile-menu__item--has-children > .mobile-menu__item-row > a[href="#"], ' +
    '.mobile-menu__submenu-item--has-children > .mobile-menu__submenu-row > a[href="#"]'
  );

  if (!parentLink) return;

  event.preventDefault();

  const row = parentLink.closest(
    '.mobile-menu__item-row, .mobile-menu__submenu-row'
  );

  const matchingToggle = row?.querySelector('[data-submenu-toggle]');

  toggleMobileSubmenu(matchingToggle);
});

const openMenu = () => {
  if (!menu) return;

  menu.classList.add('is-open');
  menu.setAttribute('aria-hidden', 'false');

  document.documentElement.classList.add('mobile-menu-open');
  document.body.classList.add('mobile-menu-open');

  const closeButton = menu.querySelector('[data-menu-close]');
  window.setTimeout(() => closeButton?.focus(), 50);
};

const closeMenu = () => {
  if (!menu) return;

  menu.classList.remove('is-open');
  menu.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove('mobile-menu-open');
  document.body.classList.remove('mobile-menu-open');

  closeAllMobileSubmenus();
};

document.addEventListener('click', event => {
  if (event.target.closest('[data-menu-open]')) {
    event.preventDefault();
    openMenu();
    return;
  }

  if (event.target.closest('[data-menu-close]')) {
    event.preventDefault();
    closeMenu();
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
    closeMenu();
  }
});

  // Account login modal
  const loginModal = $('[data-login-modal]');
  const openLogin = () => { if (loginModal) { closeMenu(); loginModal.classList.add('is-open'); loginModal.setAttribute('aria-hidden', 'false'); setTimeout(() => loginModal.querySelector('input[type=\"email\"]')?.focus(), 80); } };
  const closeLogin = () => { if (loginModal) { loginModal.classList.remove('is-open'); loginModal.setAttribute('aria-hidden', 'true'); } };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-login-open]')) { e.preventDefault(); openLogin(); }
    if (e.target.closest('[data-login-close]')) closeLogin();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeLogin(); closeCart(); closeMenu(); } });

  // Cart drawer
  const drawer = $('[data-cart-drawer]');
  const openCart = () => {
  if (!drawer) return;

  closeMenu();

  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');

  document.documentElement.classList.add('cart-drawer-open');
  document.body.classList.add('cart-drawer-open');
};

const closeCart = () => {
  if (!drawer) return;

  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove('cart-drawer-open');
  document.body.classList.remove('cart-drawer-open');
};
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]')) openCart();
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    return res.json();
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const body = $('[data-cart-body]');
    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const shippingRow = $('[data-cart-shipping]');
const shippingValue = $('[data-cart-shipping-value]');

if (shippingRow && shippingValue) {
  const threshold = Number(
    shippingRow.dataset.freeThreshold || 0
  );

  const freeLabel =
    shippingRow.dataset.freeLabel || 'FREE';

  const belowTemplate =
    shippingRow.dataset.belowTemplate ||
    'Spend [amount] more';

  const hideBelowThreshold =
    shippingRow.dataset.hideBelowThreshold === 'true';

  const hasReachedFreeShipping =
    threshold <= 0 || cart.total_price >= threshold;

  shippingRow.hidden =
    hideBelowThreshold && !hasReachedFreeShipping;

  if (hasReachedFreeShipping) {
    shippingValue.textContent = freeLabel;
  } else {
    const remainingAmount =
      threshold - cart.total_price;

    const formattedRemaining =
      formatMoney(remainingAmount);

    shippingValue.textContent = belowTemplate
      .replace('[amount]', formattedRemaining)
      .replace('{{ amount }}', formattedRemaining);
  }
}
    const checkoutForm = $('[data-cart-checkout-form]');
const checkout = checkoutForm?.querySelector('button[name="checkout"]');
const cartIsEmpty = cart.item_count === 0;

if (checkoutForm) {
  checkoutForm.hidden = cartIsEmpty;
}

if (checkout) {
  checkout.disabled = cartIsEmpty;
}
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-line" data-line-key="${item.key}">
        <a class="cart-line__media" href="${item.url}">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<div class="starry-placeholder"><span>ITEM</span></div>'}</a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title ? `<div class="cart-line__variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-line__price">${formatMoney(item.original_line_price)}</div>
          <div class="cart-line__controls">
            <button type="button" data-cart-qty data-key="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-qty data-key="${item.key}" data-quantity="${item.quantity + 1}">+</button>
          </div>
        </div>
      </div>`).join('');
  }

  function hideProductCardActions(exceptCard = null) {
    $$('.product-card.is-action-visible').forEach(card => {
      if (card !== exceptCard) card.classList.remove('is-action-visible');
    });
  }

  function flyToCart(form) {
    const card = form.closest('[data-product-card]');
    const img = card ? $('.product-card__image', card) : null;
    const cartTarget = $('[data-cart-open]');
    if (!img || !cartTarget) return Promise.resolve();
    const imgRect = img.getBoundingClientRect();
    const targetRect = cartTarget.getBoundingClientRect();
    const size = Math.min(96, Math.max(58, Math.min(imgRect.width, imgRect.height) * 0.34));
    const clone = img.cloneNode(true);
    clone.className = 'fly-to-cart';
    clone.style.width = `${size}px`;
    clone.style.height = `${size}px`;
    clone.style.left = `${imgRect.left + imgRect.width / 2 - size / 2}px`;
    clone.style.top = `${imgRect.top + imgRect.height / 2 - size / 2}px`;
    document.body.appendChild(clone);
    const dx = targetRect.left + targetRect.width / 2 - (imgRect.left + imgRect.width / 2);
    const dy = targetRect.top + targetRect.height / 2 - (imgRect.top + imgRect.height / 2);
    const midY = Math.min(dy - 70, -90);
    const animation = clone.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 0, offset: 0 },
      { transform: 'translate3d(0,0,0) scale(1.05)', opacity: 1, offset: .08 },
      { transform: `translate3d(${dx * .42}px, ${midY}px, 0) scale(.72)`, opacity: .95, offset: .58 },
      { transform: `translate3d(${dx}px, ${dy}px, 0) scale(.16)`, opacity: 0, offset: 1 }
    ], { duration: 980, easing: 'cubic-bezier(.18,.72,.18,1)', fill: 'forwards' });
    return animation.finished.catch(() => {}).then(() => clone.remove());
  }

  async function addFormToCart(form) {
    const button = form.querySelector('button[type="submit"], button[name="add"]');
    const oldText = button ? button.textContent : '';
    try {
      if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
      const body = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body, headers: { 'Accept': 'application/json' }});
      if (!res.ok) throw await res.json();
      const cart = await getCart();
      renderCart(cart);
      hideProductCardActions();
      await flyToCart(form);
      openCart();
    } catch (err) {
      console.error(err);
      alert(err?.description || 'Could not add this item to cart.');
    } finally {
      if (button) { button.disabled = false; button.textContent = oldText; }
    }
  }

  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-ajax-product-form], [data-product-form]');
    if (!form) return;
    const submitter = e.submitter;
    if (submitter && submitter.name !== 'add' && !submitter.matches('[type="submit"]')) return;
    if (submitter && submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    addFormToCart(form);
  });

  document.addEventListener('click', async e => {
    const qty = e.target.closest('[data-cart-qty]');
    const remove = e.target.closest('[data-cart-remove]');
    if (!qty && !remove) return;
    const key = (qty || remove).dataset.key;
    const quantity = remove ? 0 : Number(qty.dataset.quantity);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw await res.json();
      renderCart(await res.json());
    } catch (err) { console.error(err); }
  });

  // Product card first-tap reveal, second-tap navigation
let activeTappedProductCard = null;
let suppressProductCardClick = false;

let productCardPointerStartX = 0;
let productCardPointerStartY = 0;
let productCardPointerStartTime = 0;
let productCardWasOpenAtPointerDown = false;
let productCardPointerId = null;

function resetProductCardTapState() {
  $$('[data-product-card]').forEach(card => {
    card.classList.remove('is-action-visible');
    card.removeAttribute('data-card-tap-ready');
  });

  activeTappedProductCard = null;
}

function closeOtherProductCards(exceptCard = null) {
  $$('[data-product-card]').forEach(card => {
    if (card === exceptCard) return;

    card.classList.remove('is-action-visible');
    card.removeAttribute('data-card-tap-ready');
  });
}

/*
 * Detect whether the card action is already visibly open.
 * This recognizes both:
 *
 * 1. JavaScript's is-action-visible class
 * 2. A touch-device CSS hover state caused by tapping/holding
 */
function productCardActionIsVisible(card) {
  if (!card) return false;

  if (
    card.classList.contains('is-action-visible') ||
    card.getAttribute('data-card-tap-ready') === 'true'
  ) {
    return true;
  }

  const action = card.querySelector(
    '[data-product-card-action]'
  );

  if (!action) return false;

  const styles = window.getComputedStyle(action);

  return (
    styles.display !== 'none' &&
    styles.visibility !== 'hidden' &&
    Number(styles.opacity || 0) > 0.25
  );
}

/*
 * Clear revealed buttons on initial load and whenever
 * the page is restored with the browser Back button.
 */
resetProductCardTapState();

window.addEventListener('pageshow', () => {
  resetProductCardTapState();
});

/*
 * Record whether the action was already visible before
 * this new tap started.
 */
document.addEventListener(
  'pointerdown',
  event => {
    const media = event.target.closest(
  '[data-product-card-media]'
);

    const card = event.target.closest(
      '[data-product-card]'
    );

    if (!media || !card) {
      productCardPointerId = null;
      productCardWasOpenAtPointerDown = false;
      return;
    }

    const usesTapBehavior = window.matchMedia(
      '(max-width: 749px), (hover: none), (pointer: coarse)'
    ).matches;

    if (!usesTapBehavior) return;

    productCardPointerId = event.pointerId;
    productCardPointerStartX = event.clientX;
    productCardPointerStartY = event.clientY;
    productCardPointerStartTime = Date.now();

    /*
     * The important part:
     * check visibility before this new tap changes :hover.
     */
    productCardWasOpenAtPointerDown =
      productCardActionIsVisible(card);
  },
  true
);

document.addEventListener(
  'pointerup',
  event => {
    const action = event.target.closest(
      '[data-product-card-action]'
    );

    /*
     * Let Add to Cart, More Details and other
     * revealed controls continue working normally.
     */
    if (action) return;

    const media = event.target.closest(
      '[data-product-card-media]'
    );

    const card = event.target.closest(
      '[data-product-card]'
    );

    const usesTapBehavior = window.matchMedia(
      '(max-width: 749px), (hover: none), (pointer: coarse)'
    ).matches;

    if (!usesTapBehavior) return;

    if (!card) {
      resetProductCardTapState();
      return;
    }

    if (!media) return;

    if (
      productCardPointerId !== null &&
      event.pointerId !== productCardPointerId
    ) {
      return;
    }

    const distanceX =
      event.clientX - productCardPointerStartX;

    const distanceY =
      event.clientY - productCardPointerStartY;

    const pressDuration =
      Date.now() - productCardPointerStartTime;

    const wasHorizontalSwipe =
  Math.abs(distanceX) > 12 &&
  Math.abs(distanceX) > Math.abs(distanceY);

const wasVerticalScroll =
  Math.abs(distanceY) > 10 &&
  Math.abs(distanceY) >= Math.abs(distanceX);

const wasLongPress =
  pressDuration > 500;

const wasScrollOrHold =
  wasHorizontalSwipe ||
  wasVerticalScroll ||
  wasLongPress;

productCardPointerId = null;

/*
 * A horizontal image swipe must never reveal the card
 * buttons or open the product page.
 */
if (wasHorizontalSwipe) {
  suppressProductCardClick = true;

  window.setTimeout(() => {
    suppressProductCardClick = false;
  }, 450);

  productCardWasOpenAtPointerDown = false;
  return;
}

/*
 * Ignore vertical page scrolling and long presses.
 */
if (wasVerticalScroll || wasLongPress) {
  productCardWasOpenAtPointerDown = false;
  return;
}

    const productLink =
      media.closest('a[href*="/products/"]') ||
      media.querySelector('a[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');

    const productUrl =
      card.dataset.productUrl ||
      productLink?.href;

    const isAlreadyOpen =
      productCardWasOpenAtPointerDown ||
      (
        card === activeTappedProductCard &&
        card.getAttribute('data-card-tap-ready') === 'true'
      );

    suppressProductCardClick = true;

    window.setTimeout(() => {
      suppressProductCardClick = false;
    }, 350);

    /*
     * If the button was already visible when this tap
     * began, this tap opens the product immediately.
     */
    if (isAlreadyOpen && productUrl) {
      event.preventDefault();
      event.stopPropagation();

      resetProductCardTapState();

      window.location.assign(productUrl);

      return;
    }

    /*
     * Otherwise this is a genuine first tap:
     * reveal the card action.
     */
    event.preventDefault();
    event.stopPropagation();

    closeOtherProductCards(card);

    card.classList.add('is-action-visible');
    card.setAttribute('data-card-tap-ready', 'true');

    activeTappedProductCard = card;
  },
  true
);

/*
 * Cancel gesture tracking when the browser cancels
 * a pointer because the customer is scrolling.
 */
document.addEventListener(
  'pointercancel',
  () => {
    productCardPointerId = null;
    productCardWasOpenAtPointerDown = false;
  },
  true
);

/*
 * Stop the browser-generated click that follows pointerup.
 * Navigation or first-tap behavior was already handled above.
 */
document.addEventListener(
  'click',
  event => {
    if (!suppressProductCardClick) return;

    const media = event.target.closest(
      '[data-product-card-media]'
    );

    if (!media) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

// Mobile product-card image swiping
function initializeProductCardSliders(scope = document) {
  scope
    .querySelectorAll('[data-product-card-slider]')
    .forEach(slider => {
      if (slider.dataset.sliderInitialized === 'true') {
        return;
      }

      const track = slider.querySelector(
        '[data-product-card-track]'
      );

      const originalSlides = Array.from(
        slider.querySelectorAll(
          '[data-product-card-slide]:not([data-loop-clone])'
        )
      );

      const dots = Array.from(
        slider.querySelectorAll(
          '[data-product-card-dot]'
        )
      );

      if (!track || !originalSlides.length) {
        slider.dataset.sliderInitialized = 'true';
        return;
      }

      let scrollFrame = null;
      let resizeFrame = null;
      let swipeStartX = 0;
      let swipeStartY = 0;
      let isHorizontalSwipe = false;

      function getCurrentPhysicalSlide() {
        const allSlides = Array.from(
          track.querySelectorAll(
            '[data-product-card-slide]'
          )
        );

        if (!allSlides.length || !track.clientWidth) {
          return null;
        }

        const physicalIndex = Math.max(
          0,
          Math.min(
            allSlides.length - 1,
            Math.round(
              track.scrollLeft /
              track.clientWidth
            )
          )
        );

        return allSlides[physicalIndex];
      }

      function getRealSlideIndex(activeSlide) {
        if (!activeSlide) return 0;

        if (
          activeSlide.dataset.loopClone === 'last'
        ) {
          return originalSlides.length - 1;
        }

        if (
          activeSlide.dataset.loopClone === 'first'
        ) {
          return 0;
        }

        const realIndex =
          originalSlides.indexOf(activeSlide);

        return Math.max(0, realIndex);
      }

      function updateProductCardHeight(
        animate = true
      ) {
        const activeSlide =
          getCurrentPhysicalSlide() ||
          originalSlides[0];

        if (!activeSlide) return;

        const media = activeSlide.querySelector(
          'img, video, model-viewer'
        );

        if (!media) {
          const fallbackHeight =
            activeSlide.scrollHeight;

          if (fallbackHeight > 0) {
            track.style.height =
              `${Math.ceil(fallbackHeight)}px`;
          }

          return;
        }

        const applyHeight = () => {
          const galleryWidth =
            track.clientWidth;

          let newHeight = 0;

          if (
            media.tagName === 'IMG' &&
            media.naturalWidth > 0 &&
            media.naturalHeight > 0
          ) {
            newHeight =
              galleryWidth *
              (
                media.naturalHeight /
                media.naturalWidth
              );
          } else if (
            media.tagName === 'VIDEO' &&
            media.videoWidth > 0 &&
            media.videoHeight > 0
          ) {
            newHeight =
              galleryWidth *
              (
                media.videoHeight /
                media.videoWidth
              );
          } else {
            newHeight =
              media.getBoundingClientRect().height;
          }

          newHeight = Math.ceil(newHeight);

          if (!newHeight) return;

          if (!animate) {
            track.classList.add(
              'is-resizing-without-animation'
            );
          }

          track.style.height =
            `${newHeight}px`;

          if (!animate) {
            requestAnimationFrame(() => {
              track.classList.remove(
                'is-resizing-without-animation'
              );
            });
          }
        };

        if (
          media.tagName === 'IMG' &&
          !media.complete
        ) {
          media.addEventListener(
            'load',
            applyHeight,
            { once: true }
          );

          return;
        }

        if (
          media.tagName === 'VIDEO' &&
          !media.videoWidth
        ) {
          media.addEventListener(
            'loadedmetadata',
            applyHeight,
            { once: true }
          );

          return;
        }

        applyHeight();
      }

      function updateProductCardSlider() {
        const activeSlide =
          getCurrentPhysicalSlide();

        const activeIndex =
          getRealSlideIndex(activeSlide);

        dots.forEach((dot, index) => {
          dot.classList.toggle(
            'is-active',
            index === activeIndex
          );
        });

        updateProductCardHeight();
      }

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) {
            window.cancelAnimationFrame(
              scrollFrame
            );
          }

          scrollFrame =
            window.requestAnimationFrame(
              updateProductCardSlider
            );
        },
        { passive: true }
      );

      track.addEventListener(
        'touchstart',
        event => {
          const touch = event.touches[0];

          if (!touch) return;

          swipeStartX = touch.clientX;
          swipeStartY = touch.clientY;
          isHorizontalSwipe = false;

          slider.classList.remove(
            'is-swiping'
          );
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        event => {
          const touch = event.touches[0];

          if (!touch) return;

          const distanceX =
            touch.clientX - swipeStartX;

          const distanceY =
            touch.clientY - swipeStartY;

          if (
            Math.abs(distanceX) > 8 &&
            Math.abs(distanceX) >
              Math.abs(distanceY)
          ) {
            isHorizontalSwipe = true;

            slider.classList.add(
              'is-swiping'
            );
          }
        },
        { passive: true }
      );

      const finishSwipe = () => {
        if (isHorizontalSwipe) {
          slider.dataset.justSwiped = 'true';

          window.setTimeout(() => {
            delete slider.dataset.justSwiped;
          }, 450);
        }

        isHorizontalSwipe = false;

        slider.classList.remove(
          'is-swiping'
        );

        updateProductCardSlider();
      };

      track.addEventListener(
        'touchend',
        finishSwipe,
        { passive: true }
      );

      track.addEventListener(
        'touchcancel',
        finishSwipe,
        { passive: true }
      );

      originalSlides.forEach(slide => {
        const media = slide.querySelector(
          'img, video, model-viewer'
        );

        if (!media) return;

        const updateLoadedHeight = () => {
          const activeSlide =
            getCurrentPhysicalSlide();

          if (
            activeSlide === slide ||
            !activeSlide
          ) {
            updateProductCardHeight(false);
          }
        };

        if (media.tagName === 'IMG') {
          if (media.complete) {
            updateLoadedHeight();
          } else {
            media.addEventListener(
              'load',
              updateLoadedHeight
            );
          }
        }

        if (media.tagName === 'VIDEO') {
          media.addEventListener(
            'loadedmetadata',
            updateLoadedHeight
          );
        }
      });

      window.addEventListener(
        'resize',
        () => {
          if (resizeFrame) {
            window.cancelAnimationFrame(
              resizeFrame
            );
          }

          resizeFrame =
            window.requestAnimationFrame(
              () => {
                updateProductCardHeight(false);
              }
            );
        }
      );

      slider.dataset.sliderInitialized = 'true';

      requestAnimationFrame(() => {
        updateProductCardSlider();
      });
    });
}

initializeProductCardSliders();

document.addEventListener(
  'shopify:section:load',
  event => {
    initializeProductCardSliders(event.target);
  }
);

  // Product page variants/media/lightbox
  $$('[data-product-section]').forEach(section => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch { return; }
    const productForm = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const priceEl = $('[data-product-price]', section);
    const addBtn = $('.product-form__add', section);
    const payment = $('[data-payment-button]', section);
    const stockContainer = $('[data-stock-message]', section);
    const stockMessage = stockContainer ? $('span:last-child', stockContainer) : null;
    const mediaGrid = $('[data-product-media-grid]', section);
const desktopMediaItems = $$('[data-desktop-media-index]', section);
const desktopThumbnails = $$('[data-desktop-thumbnail]', section);
const desktopGalleryLayout = section.dataset.desktopGalleryLayout || '';
const mobileTrack = $('.main-product__mobile-track', section);
    const dots = $$('[data-dot-index]', section);
const counterCurrent = $('[data-slider-current]', section);
const mobileSlides = $$('.main-product__mobile-slide', section);

let desktopGalleryIndex = 0;

function setDesktopGalleryIndex(nextIndex, options = {}) {
  if (
    desktopGalleryLayout !== 'split_carousel' ||
    !desktopMediaItems.length
  ) {
    return;
  }

  const maximumIndex = desktopMediaItems.length - 1;

  desktopGalleryIndex = Math.min(
    maximumIndex,
    Math.max(0, Number(nextIndex) || 0)
  );

  desktopMediaItems.forEach((item, index) => {
    const isActive = index === desktopGalleryIndex;

    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    item.tabIndex = isActive ? 0 : -1;
  });

  desktopThumbnails.forEach((thumbnail, index) => {
    const isActive = index === desktopGalleryIndex;

    thumbnail.classList.toggle('is-active', isActive);
    thumbnail.setAttribute(
      'aria-current',
      isActive ? 'true' : 'false'
    );
  });


  const activeThumbnail =
    desktopThumbnails[desktopGalleryIndex];

  if (activeThumbnail && options.centerThumbnail !== false) {
    activeThumbnail.scrollIntoView({
      behavior: options.instant ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
  }
}

if (desktopGalleryLayout === 'split_carousel') {
  setDesktopGalleryIndex(0, {
    instant: true,
    centerThumbnail: false
  });

  desktopThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      setDesktopGalleryIndex(
        Number(thumbnail.dataset.desktopIndex)
      );
    });
  });
}

    const currentOptions = () => {
  const optionRoot = productForm || section;

  return $$(
    '[data-product-option]:checked',
    optionRoot
  ).map(input => input.value);
};
    const findVariant = () => product.variants.find(v => JSON.stringify(v.options) === JSON.stringify(currentOptions()));
    function variantStockState(variant) {
  const threshold = Number(
    stockContainer?.dataset.lowThreshold || 5
  );

  if (!variant || !variant.available) {
    return 'out';
  }

  /*
   * Products that Shopify does not track inventory for
   * should simply appear in stock.
   */
  if (!variant.inventory_management) {
    return 'in';
  }

  const inventoryQuantity = Number(
    variant.inventory_quantity || 0
  );

  /*
   * A variant with inventory above zero but at or below
   * the threshold is considered low stock.
   */
  if (
    inventoryQuantity > 0 &&
    inventoryQuantity <= threshold
  ) {
    return 'low';
  }

  /*
   * A zero or negative quantity can still be available when
   * "Continue selling when out of stock" is enabled.
   */
  return 'in';
}
    function updateStock(variant) {
  if (!stockContainer || !stockMessage) return;

  const state = variantStockState(variant);

  stockContainer.classList.remove(
    'product-form__stock--in',
    'product-form__stock--low',
    'product-form__stock--out'
  );

  stockContainer.classList.add(
    `product-form__stock--${state}`
  );

  if (state === 'out') {
    stockMessage.textContent =
      stockContainer.dataset.soldOut || 'Sold Out';

    return;
  }

  if (state === 'low') {
    const lowMessage =
      stockContainer.dataset.lowStock || 'Low Stock';

    const quantity = Math.max(
      0,
      Number(variant?.inventory_quantity || 0)
    );

    const quantityTemplate =
  stockContainer.dataset.lowQuantityTemplate ||
  'Only [quantity] left';

const combinedTemplate =
  stockContainer.dataset.lowCombinedTemplate ||
  'Only [quantity] left. Estimated delivery time 1-4 business days';

const quantityText = quantityTemplate.replace(
  '[quantity]',
  String(quantity)
);

const combinedText = combinedTemplate.replace(
  '[quantity]',
  String(quantity)
);

const displayStyle =
  stockContainer.dataset.lowDisplay || 'message';

if (displayStyle === 'quantity') {
  stockMessage.textContent = quantityText;
} else if (displayStyle === 'message_quantity') {
  stockMessage.textContent = combinedText;
} else {
  stockMessage.textContent = lowMessage;
}

    return;
  }

  stockMessage.textContent =
    stockContainer.dataset.inStock || 'In Stock';
}
    function updateVariant() {
  /* Update the label above each option selector */
  $$(
    '.product-form__fieldset',
    productForm || section
  ).forEach(fieldset => {
    const selectedInput = fieldset.querySelector(
      '[data-product-option]:checked'
    );

    const selectedLabel = fieldset.querySelector(
      '[data-selected-option-label]'
    );

    if (selectedInput && selectedLabel) {
      selectedLabel.textContent = selectedInput.value;
    }
  });

  const variant = findVariant();
  const addText = addBtn?.dataset.addToCartText || 'ADD TO CART';
  const soldText = addBtn?.dataset.soldOutText || 'SOLD OUT';

  if (!variant) {
    if (addBtn) {
      addBtn.textContent = soldText;
      addBtn.disabled = true;
      addBtn.type = 'button';
    }

    if (payment) payment.classList.add('is-hidden');

    if (stockContainer && stockMessage) {
      stockContainer.classList.remove('product-form__stock--in', 'product-form__stock--low', 'product-form__stock--out');
      stockContainer.classList.add('product-form__stock--out');
      stockMessage.textContent = stockContainer.dataset.soldOut || 'Sold Out';
    }

    return;
  }

  if (idInput) {
  idInput.value = variant.id;

  /*
   * Notify Shopify's accelerated checkout button that the
   * selected variant has changed.
   */
  idInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );
}
  if (priceEl) priceEl.textContent = formatMoney(variant.price);

  const isAvailable = Boolean(variant.available);

  if (addBtn) {
    addBtn.textContent = isAvailable ? addText : soldText;
    addBtn.disabled = !isAvailable;
    addBtn.type = isAvailable ? 'submit' : 'button';
    addBtn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
  }

  if (payment) {
    payment.classList.toggle('is-hidden', !isAvailable);
  }

  updateStock(variant);

  if (variant.featured_media) scrollToMedia(variant.featured_media.id);

  history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
}
    $$(
  '[data-product-option]',
  productForm || section
).forEach(input => {
  input.addEventListener('change', updateVariant);
});

    function scrollToMedia(mediaId) {
  const gridItem = mediaGrid
    ? mediaGrid.querySelector(
        `[data-media-id="${mediaId}"]`
      )
    : null;

  if (
    gridItem &&
    window.matchMedia('(min-width: 750px)').matches
  ) {
    if (desktopGalleryLayout === 'split_carousel') {
      const mediaIndex = Number(
        gridItem.dataset.desktopMediaIndex || 0
      );

      setDesktopGalleryIndex(mediaIndex);
    } else {
      gridItem.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  const mobileItem = mobileTrack
    ? mobileTrack.querySelector(
        `[data-media-id="${mediaId}"]`
      )
    : null;

  if (mobileItem) {
    mobileItem.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  }
}

if (mobileTrack) {
  const slider = mobileTrack.closest(
    '[data-product-mobile-slider]'
  );

  const realSlides = Array.from(
    mobileTrack.querySelectorAll(
      '.main-product__mobile-slide:not([data-loop-clone])'
    )
  );

  const hasMultipleImages = realSlides.length > 1;

  let currentIndex = 0;
  let allSlides = realSlides;

  const usesDesktopMouse = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  ).matches;

  function updateProductGalleryIndicators() {
  dots.forEach((dot, index) => {
    dot.classList.toggle(
      'is-active',
      index === currentIndex
    );
  });

  if (counterCurrent) {
    counterCurrent.textContent = String(
      currentIndex + 1
    );
  }

  updateProductGalleryHeight();
}

  function getSlideWidth() {
    return Math.max(
      1,
      mobileTrack.clientWidth
    );
  }

  function updateProductGalleryHeight(
  animate = true
) {
  const activeSlide =
    realSlides[currentIndex];

  if (!activeSlide) return;

  const activeMedia =
    activeSlide.querySelector(
      'img, video, model-viewer'
    );

  if (!activeMedia) return;

  const applyHeight = () => {
    const galleryWidth =
      mobileTrack.clientWidth;

    let newHeight = 0;

    if (
      activeMedia.tagName === 'IMG' &&
      activeMedia.naturalWidth > 0 &&
      activeMedia.naturalHeight > 0
    ) {
      newHeight =
        galleryWidth *
        (
          activeMedia.naturalHeight /
          activeMedia.naturalWidth
        );
    } else if (
      activeMedia.tagName === 'VIDEO' &&
      activeMedia.videoWidth > 0 &&
      activeMedia.videoHeight > 0
    ) {
      newHeight =
        galleryWidth *
        (
          activeMedia.videoHeight /
          activeMedia.videoWidth
        );
    } else {
      newHeight =
        activeMedia.getBoundingClientRect().height;
    }

    newHeight = Math.ceil(newHeight);

    if (!newHeight) return;

    if (!animate) {
      mobileTrack.classList.add(
        'is-resizing-without-animation'
      );
    }

    mobileTrack.style.height =
      `${newHeight}px`;

    if (!animate) {
      requestAnimationFrame(() => {
        mobileTrack.classList.remove(
          'is-resizing-without-animation'
        );
      });
    }
  };

  if (
    activeMedia.tagName === 'IMG' &&
    !activeMedia.complete
  ) {
    activeMedia.addEventListener(
      'load',
      applyHeight,
      { once: true }
    );

    return;
  }

  if (
    activeMedia.tagName === 'VIDEO' &&
    !activeMedia.videoWidth
  ) {
    activeMedia.addEventListener(
      'loadedmetadata',
      applyHeight,
      { once: true }
    );

    return;
  }

  applyHeight();
}

  function jumpProductGalleryWithoutAnimation(
    physicalIndex
  ) {
    const slideWidth = getSlideWidth();

    mobileTrack.style.scrollBehavior = 'auto';
    mobileTrack.style.scrollSnapType = 'none';

    mobileTrack.scrollLeft =
      physicalIndex * slideWidth;

    requestAnimationFrame(() => {
      mobileTrack.style.scrollBehavior = '';
      mobileTrack.style.scrollSnapType = '';
    });
  }

  function scrollProductGalleryToRealIndex(
    index,
    behavior = 'smooth'
  ) {
    if (!realSlides.length) return;

    currentIndex =
      (
        Number(index) +
        realSlides.length
      ) % realSlides.length;

    /*
     * Desktop/editor galleries contain one cloned image
     * at each end, so real image zero sits at position one.
     */
    const physicalIndex =
      usesDesktopMouse && hasMultipleImages
        ? currentIndex + 1
        : currentIndex;

    mobileTrack.scrollTo({
      left:
        physicalIndex *
        getSlideWidth(),
      behavior
    });

    updateProductGalleryIndicators();
  }

  /*
   * Match the Product Row desktop/editor behavior:
   * add the final image before the first and the first
   * image after the final image for seamless looping.
   */
  if (
    usesDesktopMouse &&
    hasMultipleImages &&
    !mobileTrack.querySelector(
      '[data-loop-clone]'
    )
  ) {
    const firstClone =
      realSlides[0].cloneNode(true);

    const lastClone =
      realSlides[
        realSlides.length - 1
      ].cloneNode(true);

    firstClone.dataset.loopClone = 'first';
    lastClone.dataset.loopClone = 'last';

    firstClone.setAttribute(
      'aria-hidden',
      'true'
    );

    lastClone.setAttribute(
      'aria-hidden',
      'true'
    );

    /*
     * Cloned images must not open the lightbox using
     * duplicate product media IDs.
     */
    firstClone.removeAttribute(
      'data-product-lightbox-open'
    );

    lastClone.removeAttribute(
      'data-product-lightbox-open'
    );

    mobileTrack.prepend(lastClone);
    mobileTrack.append(firstClone);

    allSlides = Array.from(
      mobileTrack.querySelectorAll(
        '.main-product__mobile-slide'
      )
    );

    requestAnimationFrame(() => {
      jumpProductGalleryWithoutAnimation(1);
      currentIndex = 0;
      updateProductGalleryIndicators();
    });
  }

  /*
   * Dots work like the Product Row dots.
   */
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      scrollProductGalleryToRealIndex(
        Number(dot.dataset.dotIndex)
      );
    });
  });

  /*
   * Native touch swiping remains enabled on phones,
   * exactly like Product Row.
   */
  if (!usesDesktopMouse) {
    let scrollFrame = null;

    mobileTrack.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(() => {
          const index = Math.round(
            mobileTrack.scrollLeft /
            getSlideWidth()
          );

          currentIndex = Math.max(
            0,
            Math.min(
              realSlides.length - 1,
              index
            )
          );

          updateProductGalleryIndicators();
        });
      },
      {
        passive: true
      }
    );

    updateProductGalleryIndicators();
  }

  /*
   * Desktop and Shopify editor dragging now use the
   * same one-image-per-drag behavior as Product Row.
   */
  if (usesDesktopMouse) {
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let startScrollLeft = 0;
    let isDragging = false;

    const dragThreshold = 3;

    function moveProductGalleryOneImage(
      direction
    ) {
      if (!hasMultipleImages) return;

      const previousIndex = currentIndex;

      currentIndex =
        (
          currentIndex +
          direction +
          realSlides.length
        ) % realSlides.length;

      let destinationPhysicalIndex =
        currentIndex + 1;

      let boundaryJumpPhysicalIndex =
        null;

      /*
       * Final real image → cloned first image.
       */
      if (
        previousIndex ===
          realSlides.length - 1 &&
        direction === 1
      ) {
        destinationPhysicalIndex =
          realSlides.length + 1;

        boundaryJumpPhysicalIndex = 1;
      }

      /*
       * First real image → cloned final image.
       */
      if (
        previousIndex === 0 &&
        direction === -1
      ) {
        destinationPhysicalIndex = 0;

        boundaryJumpPhysicalIndex =
          realSlides.length;
      }

      mobileTrack.style.scrollSnapType =
        'none';

      mobileTrack.scrollTo({
        left:
          destinationPhysicalIndex *
          getSlideWidth(),
        behavior: 'smooth'
      });

      updateProductGalleryIndicators();

      if (
        boundaryJumpPhysicalIndex !== null
      ) {
        window.setTimeout(() => {
          jumpProductGalleryWithoutAnimation(
            boundaryJumpPhysicalIndex
          );
        }, 330);
      } else {
        window.setTimeout(() => {
          mobileTrack.style.scrollSnapType =
            '';
        }, 330);
      }
    }

    mobileTrack.addEventListener(
      'pointerdown',
      event => {
        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0
        ) {
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        lastX = event.clientX;
        startScrollLeft =
          mobileTrack.scrollLeft;

        isDragging = false;

        slider?.classList.add(
          'is-pointer-down'
        );

        try {
          mobileTrack.setPointerCapture(
            pointerId
          );
        } catch (error) {
          // Pointer capture is optional.
        }
      }
    );

    mobileTrack.addEventListener(
      'pointermove',
      event => {
        if (
          pointerId === null ||
          event.pointerId !== pointerId
        ) {
          return;
        }

        lastX = event.clientX;

        const distanceX =
          event.clientX - startX;

        const distanceY =
          event.clientY - startY;

        if (
          !isDragging &&
          Math.abs(distanceX) >=
            dragThreshold &&
          Math.abs(distanceX) >
            Math.abs(distanceY)
        ) {
          isDragging = true;

          slider?.classList.add(
            'is-dragging'
          );

          mobileTrack.classList.add(
            'is-dragging'
          );

          mobileTrack.style.scrollSnapType =
            'none';
        }

        if (!isDragging) return;

        event.preventDefault();
        event.stopPropagation();

        mobileTrack.scrollLeft =
          startScrollLeft - distanceX;
      },
      {
        passive: false,
        capture: true
      }
    );

    function finishProductGalleryDrag(
      event
    ) {
      if (pointerId === null) return;

      if (
        event.pointerId !== undefined &&
        event.pointerId !== pointerId
      ) {
        return;
      }

      const completedDrag = isDragging;

      const distanceX =
        lastX - startX;

      try {
        if (
          event.pointerId !== undefined &&
          mobileTrack.hasPointerCapture(
            event.pointerId
          )
        ) {
          mobileTrack.releasePointerCapture(
            event.pointerId
          );
        }
      } catch (error) {
        // Browser may already have released it.
      }

      pointerId = null;
      isDragging = false;

      slider?.classList.remove(
        'is-pointer-down',
        'is-dragging'
      );

      mobileTrack.classList.remove(
        'is-dragging'
      );

      if (!completedDrag) {
        mobileTrack.style.scrollSnapType =
          '';
        return;
      }

      slider.dataset.justDragged = 'true';

      /*
       * Match Product Row:
       * even a small completed drag changes one image.
       */
      if (distanceX < 0) {
        moveProductGalleryOneImage(1);
      } else {
        moveProductGalleryOneImage(-1);
      }

      window.setTimeout(() => {
        delete slider.dataset.justDragged;
      }, 450);
    }

    mobileTrack.addEventListener(
      'pointerup',
      finishProductGalleryDrag,
      true
    );

    mobileTrack.addEventListener(
      'pointercancel',
      finishProductGalleryDrag,
      true
    );

    mobileTrack.addEventListener(
      'lostpointercapture',
      finishProductGalleryDrag,
      true
    );

    /*
     * Prevent dragging from opening the lightbox.
     * A normal click still opens it.
     */
    mobileTrack.addEventListener(
      'click',
      event => {
        if (
          slider?.dataset.justDragged !==
          'true'
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );

    /*
     * Keep the dots synchronized with the physical
     * position, including the cloned boundary slides.
     */
    mobileTrack.addEventListener(
      'scroll',
      () => {
        requestAnimationFrame(() => {
          const physicalIndex = Math.round(
            mobileTrack.scrollLeft /
            getSlideWidth()
          );

          if (physicalIndex === 0) {
            currentIndex =
              realSlides.length - 1;
          } else if (
            physicalIndex ===
            realSlides.length + 1
          ) {
            currentIndex = 0;
          } else {
            currentIndex =
              physicalIndex - 1;
          }

          updateProductGalleryIndicators();
        });
      },
      {
        passive: true
      }
    );
    }

      let productGalleryResizeFrame = null;

  window.addEventListener('resize', () => {
    if (productGalleryResizeFrame) {
      cancelAnimationFrame(
        productGalleryResizeFrame
      );
    }

    productGalleryResizeFrame =
      requestAnimationFrame(() => {
        updateProductGalleryHeight(false);

        const physicalIndex =
          usesDesktopMouse &&
          hasMultipleImages
            ? currentIndex + 1
            : currentIndex;

        jumpProductGalleryWithoutAnimation(
          physicalIndex
        );
      });
  });

  realSlides.forEach((slide, index) => {
    const media = slide.querySelector(
      'img, video, model-viewer'
    );

    if (!media) return;

    const updateLoadedMediaHeight = () => {
      if (index === currentIndex) {
        updateProductGalleryHeight(false);
      }
    };

    if (media.tagName === 'IMG') {
      if (media.complete) {
        updateLoadedMediaHeight();
      } else {
        media.addEventListener(
          'load',
          updateLoadedMediaHeight
        );
      }
    }

    if (media.tagName === 'VIDEO') {
      media.addEventListener(
        'loadedmetadata',
        updateLoadedMediaHeight
      );
    }
  });

  updateProductGalleryIndicators();
}

    const lightbox = $('[data-product-lightbox]', section);
const lightboxStage = $('[data-product-lightbox-stage]', section);
const lightboxImage = $('[data-product-lightbox-image]', section);
const lightboxCloseButton = $('[data-product-lightbox-close]', section);

const desktopLightboxOpeners = $$(
  '.main-product__media-item[data-product-lightbox-open]',
  section
);

const mobileLightboxOpeners = $$(
  '.main-product__mobile-slide[data-product-lightbox-open]',
  section
);

/*
 * Use one unique image per product media item.
 * Do not combine desktop and mobile copies into one duplicated list.
 */
const lightboxItems = desktopLightboxOpeners
  .map((button) => {
    const image = button.querySelector('img');

    if (!image) return null;

    return {
      button,
      image,
      mediaId: button.dataset.mediaId
    };
  })
  .filter(Boolean);

let lightboxIndex = 0;
let lightboxPointerStartX = 0;
let lightboxPointerStartY = 0;
let lightboxPointerCurrentX = 0;
let lightboxIsDragging = false;
let lightboxSuppressClick = false;
let lightboxJustOpened = false;

function normalizeLightboxIndex(index) {
  if (!lightboxItems.length) return 0;

  return (
    (index % lightboxItems.length) +
    lightboxItems.length
  ) % lightboxItems.length;
}

function updateLightboxImage(index) {
  if (!lightboxImage || !lightboxItems.length) return;

  lightboxIndex = normalizeLightboxIndex(index);

  const item = lightboxItems[lightboxIndex];
  const image = item.image;

  lightboxImage.src =
    image.currentSrc ||
    image.src ||
    image.getAttribute('src') ||
    '';

  lightboxImage.alt = image.alt || '';

  lightboxImage.style.transition = 'none';
  lightboxImage.style.transform = 'translateX(0)';
  lightboxImage.style.opacity = '1';
}

function openLightbox(index) {
  if (!lightbox || !lightboxImage || !lightboxItems.length) return;

  updateLightboxImage(index);

  lightboxJustOpened = true;

  lightbox.classList.add('is-open');
  lightbox.setAttribute('aria-hidden', 'false');

  document.documentElement.classList.add('product-lightbox-open');
  document.body.classList.add('product-lightbox-open');

  window.setTimeout(() => {
    lightboxJustOpened = false;
  }, 150);

  requestAnimationFrame(() => {
    lightboxCloseButton?.focus({ preventScroll: true });
  });
}

function closeLightbox() {
  if (!lightbox) return;

  lightbox.classList.remove('is-open');
  lightbox.classList.remove('is-dragging');
  lightbox.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove('product-lightbox-open');
  document.body.classList.remove('product-lightbox-open');

  if (lightboxImage) {
    lightboxImage.src = '';
    lightboxImage.style.transition = '';
    lightboxImage.style.transform = '';
    lightboxImage.style.opacity = '';
  }

  lightboxItems[lightboxIndex]?.button?.focus({
    preventScroll: true
  });
}

function moveLightbox(direction) {
  if (!lightboxImage || lightboxItems.length < 2) {
    resetLightboxDrag();
    return;
  }

  const exitDirection = direction > 0 ? -1 : 1;

  lightboxImage.style.transition =
    'transform 180ms ease, opacity 180ms ease';

  lightboxImage.style.transform =
    `translateX(${exitDirection * 18}%)`;

  lightboxImage.style.opacity = '0';

  window.setTimeout(() => {
    updateLightboxImage(lightboxIndex + direction);

    lightboxImage.style.transition = 'none';
    lightboxImage.style.transform =
      `translateX(${exitDirection * -18}%)`;

    lightboxImage.style.opacity = '0';

    requestAnimationFrame(() => {
      lightboxImage.style.transition =
        'transform 220ms ease, opacity 220ms ease';

      lightboxImage.style.transform = 'translateX(0)';
      lightboxImage.style.opacity = '1';
    });
  }, 180);
}

function resetLightboxDrag() {
  if (!lightboxImage) return;

  lightboxImage.style.transition =
    'transform 220ms ease, opacity 220ms ease';

  lightboxImage.style.transform = 'translateX(0)';
  lightboxImage.style.opacity = '1';

  lightbox?.classList.remove('is-dragging');
}

desktopLightboxOpeners.forEach((button, index) => {
  button.addEventListener('click', () => {
    openLightbox(index);
  });
});

mobileLightboxOpeners.forEach((button) => {
  let tapStartX = 0;
  let tapStartY = 0;
  let tapPointerId = null;

  button.addEventListener('pointerdown', (event) => {
    tapStartX = event.clientX;
    tapStartY = event.clientY;
    tapPointerId = event.pointerId;
  });

  button.addEventListener('pointerup', (event) => {
    if (event.pointerId !== tapPointerId) return;

    const distanceX = event.clientX - tapStartX;
    const distanceY = event.clientY - tapStartY;

    tapPointerId = null;

    /*
     * A movement under 12px is a tap.
     * A movement of 12px or more belongs to the gallery drag.
     */
    if (
      Math.abs(distanceX) >= 12 ||
      Math.abs(distanceY) >= 12
    ) {
      return;
    }

    const mediaId = button.dataset.mediaId;

    const index = lightboxItems.findIndex((item) => {
      return item.mediaId === mediaId;
    });

    if (index < 0) return;

    event.preventDefault();
    event.stopPropagation();

    openLightbox(index);
  });

  /*
   * Mouse click fallback for Shopify's mobile preview.
   */
  button.addEventListener('click', (event) => {
    if (event.detail === 0) return;

    const mediaId = button.dataset.mediaId;

    const index = lightboxItems.findIndex((item) => {
      return item.mediaId === mediaId;
    });

    if (index < 0) return;

    event.preventDefault();
    event.stopPropagation();

    openLightbox(index);
  });
});

lightboxCloseButton?.addEventListener('click', (event) => {
  event.stopPropagation();
  closeLightbox();
});

/*
 * Clicking anywhere in the open viewport closes it.
 * A completed drag is ignored so swiping does not also close it.
 */
lightbox?.addEventListener('click', () => {
  if (lightboxSuppressClick || lightboxJustOpened) return;

  closeLightbox();
});

lightboxStage?.addEventListener('pointerdown', (event) => {
  if (!lightbox?.classList.contains('is-open')) return;

  lightboxPointerStartX = event.clientX;
  lightboxPointerStartY = event.clientY;
  lightboxPointerCurrentX = event.clientX;
  lightboxIsDragging = false;

  lightboxStage.setPointerCapture?.(event.pointerId);
});

lightboxStage?.addEventListener('pointermove', (event) => {
  if (!lightboxStage.hasPointerCapture?.(event.pointerId)) return;

  const distanceX = event.clientX - lightboxPointerStartX;
  const distanceY = event.clientY - lightboxPointerStartY;

  lightboxPointerCurrentX = event.clientX;

  if (
    !lightboxIsDragging &&
    Math.abs(distanceX) > 8 &&
    Math.abs(distanceX) > Math.abs(distanceY)
  ) {
    lightboxIsDragging = true;
    lightbox?.classList.add('is-dragging');
  }

  if (!lightboxIsDragging || !lightboxImage) return;

  event.preventDefault();

  const resistance =
    lightboxItems.length > 1 ? 1 : 0.25;

  lightboxImage.style.transition = 'none';
  lightboxImage.style.transform =
    `translateX(${distanceX * resistance}px)`;

  lightboxImage.style.opacity = String(
    Math.max(
      0.55,
      1 - Math.abs(distanceX) / 700
    )
  );
});

function finishLightboxPointer(event) {
  if (!lightboxStage.hasPointerCapture?.(event.pointerId)) return;

  lightboxStage.releasePointerCapture?.(event.pointerId);

  const distanceX =
    lightboxPointerCurrentX - lightboxPointerStartX;

  if (!lightboxIsDragging) {
    resetLightboxDrag();
    return;
  }

  lightboxSuppressClick = true;

  window.setTimeout(() => {
    lightboxSuppressClick = false;
  }, 50);

  if (Math.abs(distanceX) >= 45) {
    /*
     * Drag left shows the next image.
     * Drag right shows the previous image.
     */
    moveLightbox(distanceX < 0 ? 1 : -1);
  } else {
    resetLightboxDrag();
  }

  lightboxIsDragging = false;
}

lightboxStage?.addEventListener(
  'pointerup',
  finishLightboxPointer
);

lightboxStage?.addEventListener(
  'pointercancel',
  finishLightboxPointer
);

document.addEventListener('keydown', (event) => {
  if (!lightbox?.classList.contains('is-open')) return;

  if (event.key === 'Escape') {
    closeLightbox();
  }

  if (event.key === 'ArrowLeft') {
    event.preventDefault();
    moveLightbox(-1);
  }

  if (event.key === 'ArrowRight') {
    event.preventDefault();
    moveLightbox(1);
  }
});
  });

  // ==========================================================
// DBRMAN — Custom On Sale filter
//
// When On Sale is selected:
// - Loads every remaining pagination page automatically
// - Displays all sale-tagged products immediately
// - Pauses normal infinite scrolling
//
// When On Sale is turned off:
// - Shopify reloads the normal first results page
// - Regular infinite scrolling resumes
// ==========================================================

let infiniteObserver = null;
let saleLoadController = null;

function getCollectionSection(scope = document) {
  if (scope?.matches?.('[data-collection-section]')) {
    return scope;
  }

  return (
    scope?.querySelector?.('[data-collection-section]') ||
    document.querySelector('[data-collection-section]')
  );
}

function saleFilterIsActive() {
  const url = new URL(window.location.href);

  return url.searchParams.get('sale') === '1';
}

function removeSaleParameter(urlValue) {
  const url = new URL(
    urlValue,
    window.location.origin
  );

  url.searchParams.delete('sale');

  return url.toString();
}

function updateSaleCheckboxes(
  section,
  isActive = saleFilterIsActive()
) {
  section
    .querySelectorAll('[data-custom-sale-filter]')
    .forEach(input => {
      input.checked = isActive;
    });
}


function getOrCreateSaleEmptyMessage(section) {
  let message = section.querySelector(
    '[data-custom-sale-empty]'
  );

  if (message) return message;

  const grid = section.querySelector(
    '[data-product-grid]'
  );

  if (!grid) return null;

  message = document.createElement('div');
  message.className = 'empty-state';
  message.dataset.customSaleEmpty = '';
  message.innerHTML =
    '<p>No sale products found.</p>';

  grid.after(message);

  return message;
}

function filterLoadedCardsForSale(section) {
  const grid = section.querySelector(
    '[data-product-grid]'
  );

  if (!grid) return [];

  const cards = Array.from(
    grid.querySelectorAll('[data-product-card]')
  );

  cards.forEach(card => {
    const isOnSale =
      card.dataset.onSale === 'true';

    card.hidden = !isOnSale;
  });

  return cards.filter(card => !card.hidden);
}

function showAllLoadedCards(section) {
  section
    .querySelectorAll(
      '[data-product-grid] [data-product-card]'
    )
    .forEach(card => {
      card.hidden = false;
    });
}

function initializeNewProductCards(scope) {
  if (
    typeof initializeProductCardSliders ===
    'function'
  ) {
    initializeProductCardSliders(scope);
  }

  if (
    typeof initProductCardMouseDragging ===
    'function'
  ) {
    initProductCardMouseDragging(scope);
  }
}

async function loadEverySalePage(section) {
  const grid = section.querySelector(
    '[data-product-grid]'
  );

  if (!grid) return;

  /*
   * Stop an older Sale-loading process before starting
   * a new one.
   */
  if (saleLoadController) {
    saleLoadController.abort();
  }

  saleLoadController = new AbortController();

  const emptyMessage =
    getOrCreateSaleEmptyMessage(section);

  if (emptyMessage) {
    emptyMessage.hidden = true;
  }

  /*
   * Hide non-sale cards from the first loaded page
   * immediately while later pages are retrieved.
   */
  filterLoadedCardsForSale(section);

  let nextLink = section.querySelector(
    '[data-infinite-next]'
  );

  const fetchedUrls = new Set();
  let pageSafetyLimit = 0;

  while (
    nextLink &&
    saleFilterIsActive() &&
    pageSafetyLimit < 100
  ) {
    pageSafetyLimit += 1;

    const nextUrl = removeSaleParameter(
      nextLink.href
    );

    if (fetchedUrls.has(nextUrl)) {
      break;
    }

    fetchedUrls.add(nextUrl);

    let response;

    try {
      response = await fetch(nextUrl, {
        signal: saleLoadController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }

      throw error;
    }

    if (!response.ok) {
      throw new Error(
        `Could not load sale products: ${response.status}`
      );
    }

    const html = await response.text();

    if (!saleFilterIsActive()) {
      return;
    }

    const documentFromResponse =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const newGrid =
      documentFromResponse.querySelector(
        '[data-product-grid]'
      );

    const newNextLink =
      documentFromResponse.querySelector(
        '[data-infinite-next]'
      );

    if (newGrid) {
      /*
       * Remove empty-state messages from the fetched
       * markup before appending its product cards.
       */
      newGrid
  .querySelectorAll(
    '[data-custom-sale-empty], ' +
    '.empty-state'
  )
        .forEach(element => {
          element.remove();
        });

      const temporaryWrapper =
        document.createElement('div');

      temporaryWrapper.innerHTML =
        newGrid.innerHTML;

      const newCards = Array.from(
        temporaryWrapper.querySelectorAll(
          '[data-product-card]'
        )
      );

      newCards.forEach(card => {
        /*
         * Only append Sale products. This avoids briefly
         * inserting and hiding dozens of unrelated cards.
         */
        if (card.dataset.onSale === 'true') {
          grid.appendChild(card);
        }
      });

      initializeNewProductCards(grid);
    }

    if (newNextLink) {
      /*
       * Reuse the existing pagination element so only one
       * infinite-scroll marker exists in the live section.
       */
      nextLink.href = removeSaleParameter(
        newNextLink.href
      );
    } else {
      nextLink.remove();
      nextLink = null;
    }
  }

  const visibleSaleCards =
    filterLoadedCardsForSale(section);


  if (emptyMessage) {
    emptyMessage.hidden =
      visibleSaleCards.length > 0;
  }
}

async function applyCustomSaleFilter(
  scope = document
) {
  const section = getCollectionSection(scope);

  if (!section) return;

  const saleIsActive =
    saleFilterIsActive();

  updateSaleCheckboxes(
    section,
    saleIsActive
  );

  const emptyMessage =
    section.querySelector(
      '[data-custom-sale-empty]'
    );

  if (!saleIsActive) {
    if (saleLoadController) {
      saleLoadController.abort();
      saleLoadController = null;
    }

    showAllLoadedCards(section);

    if (emptyMessage) {
      emptyMessage.hidden = true;
    }

    return;
  }

  /*
   * Sale mode owns pagination, so normal infinite
   * scrolling must be disconnected.
   */
  if (infiniteObserver) {
    infiniteObserver.disconnect();
  }

  try {
    await loadEverySalePage(section);
  } catch (error) {
    console.error(error);

  }
}


// Collection filters and sorting without a full reload
async function refreshCollection(form) {
  const section = form.closest(
    '[data-collection-section]'
  );

  if (!section) return;

  const url = new URL(
    window.location.href
  );

  const formData = new FormData(form);
  const params = new URLSearchParams(
    formData
  );

  const saleInput = form.querySelector(
    '[data-custom-sale-filter]'
  );

  params.delete('sale');

  if (saleInput?.checked) {
    params.set('sale', '1');
  }

  /*
   * Always request page one when filters or sorting
   * change.
   */
  params.delete('page');

  url.search = params.toString();

  try {
    section.classList.add('is-loading');

    if (saleLoadController) {
      saleLoadController.abort();
      saleLoadController = null;
    }

    const fetchUrl =
      removeSaleParameter(url.toString());

    const response = await fetch(fetchUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(
        `Collection refresh failed: ${response.status}`
      );
    }

    const html = await response.text();

    const documentFromResponse =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const freshSection =
      documentFromResponse.querySelector(
        '[data-collection-section]'
      );

    if (!freshSection) return;

    section.innerHTML =
      freshSection.innerHTML;

    history.replaceState(
      {},
      '',
      url.toString()
    );

    initializeNewProductCards(section);

    if (saleFilterIsActive()) {
      await applyCustomSaleFilter(section);
    } else {
      initInfiniteScroll();
    }
  } catch (error) {
    console.error(error);

    /*
     * Fall back to a normal page load if the AJAX
     * request fails.
     */
    window.location.assign(
      url.toString()
    );
  } finally {
    section.classList.remove(
      'is-loading'
    );
  }
}

document.addEventListener(
  'change',
  event => {
    const form = event.target.closest(
      '[data-collection-filters]'
    );

    if (!form) return;

    event.preventDefault();

    refreshCollection(form);
  }
);


// Normal collection infinite scrolling
function initInfiniteScroll() {
  if (infiniteObserver) {
    infiniteObserver.disconnect();
  }

  /*
   * Sale mode loads all pages itself.
   */
  if (saleFilterIsActive()) {
    return;
  }

  const section =
    document.querySelector(
      '[data-collection-section]'
    );

  const nextLink =
    section?.querySelector(
      '[data-infinite-next]'
    );

  const grid =
    section?.querySelector(
      '[data-product-grid]'
    );

  if (!section || !nextLink || !grid) {
    return;
  }

  let loading = false;

  infiniteObserver =
    new IntersectionObserver(
      async entries => {
        if (
          !entries[0].isIntersecting ||
          loading
        ) {
          return;
        }

        loading = true;

        try {
          const response = await fetch(
            removeSaleParameter(
              nextLink.href
            ),
            {
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest'
              }
            }
          );

          if (!response.ok) {
            throw new Error(
              `Infinite scroll failed: ${response.status}`
            );
          }

          const html =
            await response.text();

          const documentFromResponse =
            new DOMParser().parseFromString(
              html,
              'text/html'
            );

          const newGrid =
            documentFromResponse.querySelector(
              '[data-product-grid]'
            );

          const newNextLink =
            documentFromResponse.querySelector(
              '[data-infinite-next]'
            );

          if (newGrid) {
            grid.insertAdjacentHTML(
              'beforeend',
              newGrid.innerHTML
            );

            initializeNewProductCards(
              grid
            );
          }

          if (newNextLink) {
            nextLink.href =
              removeSaleParameter(
                newNextLink.href
              );

            loading = false;
          } else {
            infiniteObserver.disconnect();
            nextLink.remove();
          }
        } catch (error) {
          console.error(error);
          loading = false;
        }
      },
      {
        rootMargin: '900px 0px'
      }
    );

  infiniteObserver.observe(nextLink);
}


if (saleFilterIsActive()) {
  applyCustomSaleFilter(document);
} else {
  initInfiniteScroll();
}

// Product recommendations section rendering
$$('product-recommendations').forEach(async el => {
  if (
    !el.dataset.url ||
    el.querySelector(
      '.product-card:not(.product-card--placeholder)'
    )
  ) {
    return;
  }

  try {
    const res = await fetch(el.dataset.url);
    const html = await res.text();

    const doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const fresh = doc.querySelector(
      'product-recommendations'
    );

    if (
      fresh &&
      fresh.innerHTML.trim()
    ) {
      el.innerHTML = fresh.innerHTML;

      /*
       * Shopify recommendations are inserted after the
       * initial page load, so initialize their card sliders
       * and desktop dragging after inserting the HTML.
       */
      initializeNewProductCards(el);
    }
  } catch (err) {
    console.error(err);
  }
});

  // Edge fades for collection scrollers
    function updateFade(el) {
  const overflowAmount =
    el.scrollWidth - el.clientWidth;

  const hasOverflow = overflowAmount > 2;
  const left =
    hasOverflow && el.scrollLeft > 2;
  const right =
    hasOverflow &&
    el.scrollLeft + el.clientWidth <
      el.scrollWidth - 2;

  el.classList.toggle(
    'has-horizontal-overflow',
    hasOverflow
  );

  el.classList.toggle(
    'has-no-horizontal-overflow',
    !hasOverflow
  );

  el.classList.toggle(
    'is-overflow-left',
    left
  );

  el.classList.toggle(
    'is-overflow-right',
    right
  );

  const collectionWrapper =
    el.closest('.collection-tabs');

  if (collectionWrapper) {
    collectionWrapper.classList.toggle(
      'has-horizontal-overflow',
      hasOverflow
    );

    collectionWrapper.classList.toggle(
      'has-no-horizontal-overflow',
      !hasOverflow
    );

    collectionWrapper.classList.toggle(
      'has-overflow-left',
      left
    );

    collectionWrapper.classList.toggle(
      'has-overflow-right',
      right
    );
  }

  const styledWrapper =
    el.closest('.styled-by__viewport');

  if (styledWrapper) {
    styledWrapper.classList.toggle(
      'has-overflow-left',
      left
    );

    styledWrapper.classList.toggle(
      'has-overflow-right',
      right
    );
  }
}
  function initFadeScrollers(scope = document) {
    $$('[data-fade-scroll]', scope).forEach(el => {
      updateFade(el);
      el.addEventListener('scroll', () => updateFade(el), { passive: true });
      window.addEventListener('resize', () => updateFade(el));
      setTimeout(() => updateFade(el), 50);
    });
  }
  initFadeScrollers();

    function initStyledByScrollers(scope = document) {
    $$('[data-styled-scroll]', scope).forEach(scroller => {
      if (scroller.dataset.styledScrollReady === 'true') return;

      scroller.dataset.styledScrollReady = 'true';

      let pointerDown = false;
      let dragging = false;
      let startX = 0;
      let startingScrollLeft = 0;

      scroller.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch') return;

        pointerDown = true;
        dragging = false;
        startX = event.clientX;
        startingScrollLeft = scroller.scrollLeft;

        scroller.classList.add('is-pointer-down');
        scroller.setPointerCapture?.(event.pointerId);
      });

      scroller.addEventListener('pointermove', event => {
        if (!pointerDown) return;

        const distance = event.clientX - startX;

        if (Math.abs(distance) > 5) {
          dragging = true;
          scroller.classList.add('is-dragging');
        }

        if (dragging) {
          event.preventDefault();
          scroller.scrollLeft = startingScrollLeft - distance;
          updateFade(scroller);
        }
      });

      const finishStyledDrag = event => {
        if (!pointerDown) return;

        pointerDown = false;
        scroller.classList.remove('is-pointer-down');

        scroller.releasePointerCapture?.(event.pointerId);

        window.setTimeout(() => {
          scroller.classList.remove('is-dragging');
          dragging = false;
          updateFade(scroller);
        }, 0);
      };

      scroller.addEventListener('pointerup', finishStyledDrag);
      scroller.addEventListener('pointercancel', finishStyledDrag);
      scroller.addEventListener('pointerleave', event => {
        if (pointerDown) finishStyledDrag(event);
      });

      scroller.addEventListener(
        'click',
        event => {
          if (!dragging) return;

          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    });
  }

  initStyledByScrollers();

/*
 * Collection tile dragging for desktop and Shopify mobile preview.
 * Uses delegated document listeners so dynamically rendered
 * sections and Shopify's editor preview both work.
 */
let activeCollectionScroller = null;
let collectionDragStartX = 0;
let collectionDragStartScrollLeft = 0;
let collectionDragMoved = false;
let blockCollectionTileClick = false;

document.addEventListener(
  'mousedown',
  event => {
    if (event.button !== 0) return;

    const scroller = event.target.closest(
      '[data-collection-tile-scroller], .collection-tabs__scroller'
    );

    if (!scroller) return;

    if (
      event.target.closest(
        'button, input, select, textarea'
      )
    ) {
      return;
    }

    activeCollectionScroller = scroller;
    collectionDragStartX = event.clientX;
    collectionDragStartScrollLeft = scroller.scrollLeft;
    collectionDragMoved = false;

    scroller.classList.add('is-pointer-down');

    event.preventDefault();
  },
  true
);

document.addEventListener(
  'mousemove',
  event => {
    if (!activeCollectionScroller) return;

    const distanceX =
      event.clientX - collectionDragStartX;

    if (
      !collectionDragMoved &&
      Math.abs(distanceX) >= 4
    ) {
      collectionDragMoved = true;

      activeCollectionScroller.classList.add(
        'is-dragging'
      );
    }

    if (!collectionDragMoved) return;

    event.preventDefault();

    activeCollectionScroller.scrollLeft =
      collectionDragStartScrollLeft - distanceX;

    updateFade(activeCollectionScroller);
  },
  true
);

function finishCollectionTileDrag() {
  if (!activeCollectionScroller) return;

  activeCollectionScroller.classList.remove(
    'is-pointer-down'
  );

  activeCollectionScroller.classList.remove(
    'is-dragging'
  );

  if (collectionDragMoved) {
    blockCollectionTileClick = true;

    window.setTimeout(() => {
      blockCollectionTileClick = false;
    }, 250);
  }

  activeCollectionScroller = null;
  collectionDragMoved = false;
}

document.addEventListener(
  'mouseup',
  finishCollectionTileDrag,
  true
);

window.addEventListener(
  'blur',
  finishCollectionTileDrag
);

document.addEventListener(
  'click',
  event => {
    if (!blockCollectionTileClick) return;

    const tile = event.target.closest(
      '.collection-tabs__tile'
    );

    if (!tile) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

document.addEventListener(
  'dragstart',
  event => {
    if (
      event.target.closest(
        '[data-collection-tile-scroller], .collection-tabs__scroller'
      )
    ) {
      event.preventDefault();
    }
  },
  true
);

document.addEventListener(
  'shopify:section:load',
  event => {
    initFadeScrollers(event.target);
    initStyledByScrollers(event.target);

    window.requestAnimationFrame(() => {
      event.target
        .querySelectorAll('[data-fade-scroll]')
        .forEach(updateFade);
    });
  }
);

document.addEventListener(
  'shopify:block:select',
  event => {
    const section =
      event.target.closest('.shopify-section') ||
      document;

    window.requestAnimationFrame(() => {
      section
        .querySelectorAll('[data-fade-scroll]')
        .forEach(updateFade);
    });
  }
);

document.addEventListener(
  'shopify:block:deselect',
  event => {
    const section =
      event.target.closest('.shopify-section') ||
      document;

    window.requestAnimationFrame(() => {
      section
        .querySelectorAll('[data-fade-scroll]')
        .forEach(updateFade);
    });
  }
);

document.addEventListener(
  'shopify:block:reorder',
  () => {
    window.requestAnimationFrame(() => {
      document
        .querySelectorAll('[data-fade-scroll]')
        .forEach(updateFade);
    });
  }
);
})();






/* Starry v1.6 — Mobile purchase form portal */

(() => {
  const mobileBreakpoint = window.matchMedia(
    '(max-width: 749px)'
  );

  let activeForm = null;
  let activePlaceholder = null;
  let resizeObserver = null;
  let reconcileTimer = null;

  function clearReservedSpace() {
    document.documentElement.style.removeProperty(
      '--mobile-purchase-panel-height'
    );

    document.body.classList.remove(
      'has-mobile-purchase-portal'
    );
  }

  function disconnectObserver() {
    if (!resizeObserver) return;

    resizeObserver.disconnect();
    resizeObserver = null;
  }

  function restoreActiveForm() {
    disconnectObserver();

    if (activeForm) {
      delete activeForm.dataset.mobilePurchasePortal;

      if (activePlaceholder?.isConnected) {
        activePlaceholder.parentNode.insertBefore(
          activeForm,
          activePlaceholder
        );

        activePlaceholder.remove();
      } else {
        activeForm.remove();
      }
    }

    activeForm = null;
    activePlaceholder = null;

    clearReservedSpace();
  }

  function removeOrphanedForms() {
    document.body
      .querySelectorAll(
        ':scope > form.product-form[data-mobile-purchase-portal]'
      )
      .forEach(form => {
        if (form !== activeForm) {
          form.remove();
        }
      });
  }

  function updateReservedSpace() {
    if (
      !activeForm ||
      !activeForm.isConnected ||
      activeForm.parentElement !== document.body
    ) {
      clearReservedSpace();
      return;
    }

    const height = Math.ceil(
      activeForm.getBoundingClientRect().height
    );

    document.documentElement.style.setProperty(
      '--mobile-purchase-panel-height',
      `${height}px`
    );

    document.body.classList.add(
      'has-mobile-purchase-portal'
    );
  }

  function portalCurrentForm() {
    restoreActiveForm();
    removeOrphanedForms();

    if (!mobileBreakpoint.matches) return;

    const stickySection = document.querySelector(
      '.main-product.main-product--sticky-mobile-purchase'
    );

    if (!stickySection) return;

    const form = stickySection.querySelector(
      'form.product-form[data-product-form]'
    );

    if (!form) return;

    activePlaceholder = document.createComment(
      'mobile-purchase-form-placeholder'
    );

    form.parentNode.insertBefore(
      activePlaceholder,
      form
    );

    form.dataset.mobilePurchasePortal = '';
    document.body.appendChild(form);

    activeForm = form;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        updateReservedSpace();
      });

      resizeObserver.observe(form);
    }

    updateReservedSpace();

    requestAnimationFrame(() => {
      updateReservedSpace();
    });
  }

  function scheduleReconciliation() {
    window.clearTimeout(reconcileTimer);

    reconcileTimer = window.setTimeout(() => {
      portalCurrentForm();
    }, 250);
  }

  scheduleReconciliation();

  if (mobileBreakpoint.addEventListener) {
    mobileBreakpoint.addEventListener(
      'change',
      scheduleReconciliation
    );
  } else {
    mobileBreakpoint.addListener(
      scheduleReconciliation
    );
  }

  document.addEventListener(
    'shopify:section:load',
    scheduleReconciliation
  );

  document.addEventListener(
    'shopify:section:unload',
    scheduleReconciliation
  );

  document.addEventListener(
    'shopify:section:reorder',
    scheduleReconciliation
  );
})();






/* ==========================================================
   PRODUCT CARD DESKTOP CLICK + SEAMLESS DRAG

   - Single click opens the product
   - Slight mouse drag changes one image
   - Last image loops smoothly to first
   - First image loops smoothly to last
   - Single-image cards remain clickable
   - Mobile keeps its native swipe behavior
   ========================================================== */

function initProductCardMouseDragging(scope = document) {
  const sliders = scope.querySelectorAll(
    '[data-product-card-slider]'
  );

  sliders.forEach(slider => {
    if (slider.dataset.mouseDraggingReady === 'true') {
      return;
    }

    const track = slider.querySelector(
      '[data-product-card-track]'
    );

    const card = slider.closest(
      '[data-product-card]'
    );

    if (!track || !card) return;

    const realSlides = Array.from(
      track.querySelectorAll(
        '[data-product-card-slide]:not([data-loop-clone])'
      )
    );

    const dots = Array.from(
      slider.querySelectorAll(
        '[data-product-card-dot]'
      )
    );

    const hasMultipleImages =
      realSlides.length > 1;

    slider.classList.toggle(
      'is-single-image',
      !hasMultipleImages
    );

    const usesDesktopMouse = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;

    /*
     * Mobile and touch devices keep the theme's existing
     * native swipe and first-tap behavior.
     */
    if (!usesDesktopMouse) {
      slider.dataset.mouseDraggingReady = 'true';
      return;
    }

    let allSlides = realSlides;
    let currentIndex = 0;

    /*
     * Add one clone to each end so the boundary transition
     * only moves one slide instead of scrolling across
     * the entire gallery.
     */
    if (hasMultipleImages) {
      const firstClone =
        realSlides[0].cloneNode(true);

      const lastClone =
        realSlides[
          realSlides.length - 1
        ].cloneNode(true);

      firstClone.dataset.loopClone = 'first';
      lastClone.dataset.loopClone = 'last';

      firstClone.setAttribute(
        'aria-hidden',
        'true'
      );

      lastClone.setAttribute(
        'aria-hidden',
        'true'
      );

      track.prepend(lastClone);
      track.append(firstClone);

      allSlides = Array.from(
        track.querySelectorAll(
          '[data-product-card-slide]'
        )
      );

      /*
       * The real first image is now physical slide 1,
       * because the cloned final image is at slide 0.
       */
      requestAnimationFrame(() => {
  const slideWidth =
    track.clientWidth;

  if (!slideWidth) return;

  track.style.scrollBehavior = 'auto';
  track.style.scrollSnapType = 'none';
  track.scrollLeft = slideWidth;
  currentIndex = 0;

  requestAnimationFrame(() => {
    track.style.scrollBehavior = '';
    track.style.scrollSnapType = '';
    updateDots();
  });
});
    }

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let startScrollLeft = 0;
    let isDragging = false;

    /*
     * A very small deliberate horizontal movement counts.
     */
    const dragThreshold = 3;

    function getProductUrl() {
      return (
        card.dataset.productUrl ||
        card.querySelector(
          'a[href*="/products/"]'
        )?.href ||
        ''
      );
    }

    function updateDots() {
      dots.forEach((dot, index) => {
        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );
      });
    }

    function jumpWithoutAnimation(
      physicalIndex
    ) {
      const slideWidth =
        track.clientWidth;

      if (!slideWidth) return;

      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';

      track.scrollLeft =
        physicalIndex * slideWidth;

      requestAnimationFrame(() => {
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
      });
    }

    function moveOneImage(direction) {
      if (!hasMultipleImages) return;

      const slideWidth =
        track.clientWidth;

      if (!slideWidth) return;

      const previousIndex =
        currentIndex;

      currentIndex =
        (
          currentIndex +
          direction +
          realSlides.length
        ) % realSlides.length;

      let destinationPhysicalIndex =
        currentIndex + 1;

      let boundaryJumpPhysicalIndex =
        null;

      /*
       * Final real image → cloned first image.
       */
      if (
        previousIndex ===
          realSlides.length - 1 &&
        direction === 1
      ) {
        destinationPhysicalIndex =
          realSlides.length + 1;

        boundaryJumpPhysicalIndex = 1;
      }

      /*
       * First real image → cloned final image.
       */
      if (
        previousIndex === 0 &&
        direction === -1
      ) {
        destinationPhysicalIndex = 0;

        boundaryJumpPhysicalIndex =
          realSlides.length;
      }

      track.style.scrollSnapType = 'none';

      track.scrollTo({
        left:
          destinationPhysicalIndex *
          slideWidth,
        behavior: 'smooth'
      });

      updateDots();

      /*
       * After reaching a clone, silently jump to its
       * identical real slide. The customer never sees
       * the reset.
       */
      if (
        boundaryJumpPhysicalIndex !== null
      ) {
        window.setTimeout(() => {
          jumpWithoutAnimation(
            boundaryJumpPhysicalIndex
          );
        }, 330);
      } else {
        window.setTimeout(() => {
          track.style.scrollSnapType = '';
        }, 330);
      }
    }

    slider.addEventListener(
      'pointerdown',
      event => {
        if (event.pointerType !== 'mouse') {
          return;
        }

        if (event.button !== 0) return;

        /*
         * Never start an image gesture from a card button.
         */
        if (
          event.target.closest(
            '[data-product-card-action]'
          )
        ) {
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        lastX = event.clientX;
        startScrollLeft =
          track.scrollLeft;

        isDragging = false;

        slider.classList.add(
          'is-pointer-down'
        );

        try {
          slider.setPointerCapture(
            pointerId
          );
        } catch (error) {
          // Pointer capture is optional.
        }
      }
    );

    slider.addEventListener(
      'pointermove',
      event => {
        if (
          pointerId === null ||
          event.pointerId !== pointerId
        ) {
          return;
        }

        lastX = event.clientX;

        const distanceX =
          event.clientX - startX;

        const distanceY =
          event.clientY - startY;

        if (
          !isDragging &&
          Math.abs(distanceX) >=
            dragThreshold &&
          Math.abs(distanceX) >
            Math.abs(distanceY)
        ) {
          isDragging = true;

          slider.classList.add(
            'is-dragging'
          );

          track.classList.add(
            'is-dragging'
          );

          track.style.scrollSnapType =
            'none';
        }

        if (!isDragging) return;

        event.preventDefault();
        event.stopPropagation();

        /*
         * Follow the pointer while dragging.
         */
        track.scrollLeft =
          startScrollLeft - distanceX;
      },
      {
        passive: false,
        capture: true
      }
    );

    function finishDragging(event) {
      if (pointerId === null) return;

      if (
        event.pointerId !== undefined &&
        event.pointerId !== pointerId
      ) {
        return;
      }

      const completedDrag =
        isDragging;

      const distanceX =
        lastX - startX;

      try {
        if (
          event.pointerId !== undefined &&
          slider.hasPointerCapture(
            event.pointerId
          )
        ) {
          slider.releasePointerCapture(
            event.pointerId
          );
        }
      } catch (error) {
        // Browser may already have released it.
      }

      pointerId = null;
      isDragging = false;

      slider.classList.remove(
        'is-pointer-down',
        'is-dragging'
      );

      track.classList.remove(
        'is-dragging'
      );

      if (!completedDrag) {
        track.style.scrollSnapType = '';
        return;
      }

      slider.dataset.justDragged =
        'true';

      card.dataset.productCardJustSwiped =
        'true';

      /*
       * Even a slight drag changes exactly one image.
       */
      if (distanceX < 0) {
        moveOneImage(1);
      } else {
        moveOneImage(-1);
      }

      window.setTimeout(() => {
        delete slider.dataset.justDragged;
        delete card.dataset.productCardJustSwiped;
      }, 450);
    }

    slider.addEventListener(
      'pointerup',
      finishDragging,
      true
    );

    slider.addEventListener(
      'pointercancel',
      finishDragging,
      true
    );

    slider.addEventListener(
      'lostpointercapture',
      finishDragging,
      true
    );

    slider.addEventListener(
      'click',
      event => {
        /*
         * Never allow the synthetic click after a drag
         * to open the product.
         */
        if (
          slider.dataset.justDragged ===
          'true'
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }

        if (
          event.target.closest(
            '[data-product-card-action]'
          )
        ) {
          return;
        }

        const productUrl =
          getProductUrl();

        if (!productUrl) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        window.location.assign(
          productUrl
        );
      },
      true
    );

    /*
 * Translate the physical slide position back into the
 * real product-image index. The extra first and last
 * slides are only loop clones.
 */
track.addEventListener(
  'scroll',
  () => {
    if (!hasMultipleImages || !track.clientWidth) {
      currentIndex = 0;
      updateDots();
      return;
    }

    window.requestAnimationFrame(() => {
      const physicalIndex = Math.round(
        track.scrollLeft / track.clientWidth
      );

      if (physicalIndex === 0) {
        currentIndex = realSlides.length - 1;
      } else if (
        physicalIndex === realSlides.length + 1
      ) {
        currentIndex = 0;
      } else {
        currentIndex = physicalIndex - 1;
      }

      updateDots();
    });
  },
  { passive: true }
);

slider.dataset.mouseDraggingReady =
  'true';

/*
 * The real first image sits after the cloned final image,
 * but the first dot must remain active.
 */
currentIndex = 0;

window.requestAnimationFrame(() => {
  updateDots();
});
  });
}

initProductCardMouseDragging();

/*
 * Shopify reloads section HTML while using the Theme Editor,
 * so initialize the sliders again after every section reload.
 */
document.addEventListener(
  'shopify:section:load',
  event => {
    initProductCardMouseDragging(event.target);
  }
);

document.addEventListener(
  'shopify:section:reorder',
  event => {
    initProductCardMouseDragging(event.target);
  }
);



/*
 * DBRMAN — Allow one-letter storefront searches.
 * Shopify may return no results for a single plain character,
 * so submit it as a prefix wildcard such as a*.
 */
document.addEventListener('submit', (event) => {
  const form = event.target.closest(
    '[data-main-search-form], [data-header-search] form'
  );

  if (!form) return;

  const input = form.querySelector('input[name="q"]');
  if (!input) return;

  const query = input.value.trim().replace(/\*+$/, '');

  if (query.length === 1) {
    input.value = `${query}*`;
  }
});









/* Collection tile desktop arrow scrolling */
document.querySelectorAll('.collection-tabs').forEach(tabs => {
  const scroller = tabs.querySelector(
    '[data-collection-tile-scroller], .collection-tabs__scroller'
  );

  const leftButton = tabs.querySelector('[data-collection-scroll-left]');
  const rightButton = tabs.querySelector('[data-collection-scroll-right]');

  if (!scroller || !leftButton || !rightButton) return;

  const updateButtons = () => {
  const maxScroll = scroller.scrollWidth - scroller.clientWidth;

  const canScrollLeft = scroller.scrollLeft > 2;
  const canScrollRight = scroller.scrollLeft < maxScroll - 2;

  leftButton.hidden = !canScrollLeft;
  rightButton.hidden = !canScrollRight;
};

  leftButton.addEventListener('click', () => {
    scroller.scrollBy({
      left: -Math.max(scroller.clientWidth * 0.6, 300),
      behavior: 'smooth'
    });
  });

  rightButton.addEventListener('click', () => {
    scroller.scrollBy({
      left: Math.max(scroller.clientWidth * 0.6, 300),
      behavior: 'smooth'
    });
  });

  scroller.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);

  updateButtons();
});